/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packing_List_Col_QtyInputs */

const en_packing_list_col_qty = /** @type {(inputs: Packing_List_Col_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Units`)
};

/**
* | output |
* | --- |
* | "Units" |
*
* @param {Packing_List_Col_QtyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const packing_list_col_qty = /** @type {((inputs?: Packing_List_Col_QtyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packing_List_Col_QtyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_packing_list_col_qty(inputs)
});